import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControlsUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGamepadControlsUp"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H16V7.16421L12 11.1642L8 7.16421V2ZM10 4V6.33579L12 8.33579L14 6.33579V4H10Z" fill="currentColor"/><Path d="M22 8H16.8358L12.8358 12L16.8358 16H22V8Z" fill="currentColor"/><Path d="M16 22.25V16.8358L12 12.8358L8 16.8358V22.25H16Z" fill="currentColor"/><Path d="M2 8V16H7.16421L11.1642 12L7.16421 8H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControlsUp;
